import mozjexl from 'mozjexl';

const forms = [];

document.querySelectorAll('form').forEach(form => {
    // only add event listeners and check conditions if form has conditions
    const conditions = form.querySelectorAll('[data-show-condition]');
    if (conditions.length === 0)
        return;

    function getFormValues() {
        const regex = /^tx_form_formframework\[.*?]\[(.*?)]/
        const formData = new FormData(form);
        const formValues = {};
        for (const [key, value] of formData) {
            const matched = regex.exec(key);
            if (!matched) continue;
            formValues[matched[1]] = value;
        }
        return formValues;
    }

    function checkConditions() {
        const context = {
            formValues: getFormValues(),
        };
        conditions.forEach(el => {
            const condition = el.dataset.showCondition;
            mozjexl.eval(condition, context).then(result => {
                if (result) {
                    // el.style.height = el.scrollHeight + 'px';
                    el.style.display = '';

                    // add all required-attributes to childrens
                    el.querySelectorAll('[data-required]').forEach(child => {
                        child.required = true;
                        delete child.dataset.required;
                    })
                } else {
                    el.style.display = 'none';
                    // el.style.height = '0px';

                    // remove all required-attributes from childrens
                    el.querySelectorAll('[required]').forEach(child => {
                        child.required = false;
                        child.dataset.required = 'true';
                    })
                }
            })
        })
    }

    form.addEventListener('change', function() {
        checkConditions();
    })

    checkConditions();
});

